import axios from "axios";
import Cookies from "universal-cookie";

export const login = async (email, password, options = {}) => {
  const { captchaToken, captchaType } = options || {};
  const body = { email, password };
  if (captchaToken) {
    body.captchaToken = captchaToken;
    body.captchaType = captchaType || 'recaptcha';
  }
  return await axios.post(`${process.env.REACT_APP_API}/auth/login`, body);
};

export const sendmail = async (email) => {
  return await axios.post(`${process.env.REACT_APP_API}/auth/sendmail`, {
    email,
  });
};

export const verifyOtp = async (userId, otp) => {
  return await axios.post(`${process.env.REACT_APP_API}/auth/verifyotp`, {
    userId,
    otp,
  });
};

export const resendotp = async (email) => {
  return await axios.post(`${process.env.REACT_APP_API}/auth/resendotp`, {
    email,
  });
};

export const generatepassword = async (userId, password) => {
  return await axios.post(
    `${process.env.REACT_APP_API}/auth/generatepassword`,
    {
      userId,
      password,
    }
  );
};

export const refreshToken = async (email, refreshToken) => {
  return await axios.post(`${process.env.REACT_APP_API}/auth/refreshToken`, {
    email,
    refreshToken,
  });
};

// 2FA Functions
export const setup2FA = async (token) => {
  return await axios.post(`${process.env.REACT_APP_API}/2fa/setup`, {}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const verify2FA = async (token, code) => {
  return await axios.post(`${process.env.REACT_APP_API}/2fa/verify-token`, {
    token: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const enable2FA = async (token, code) => {
  return await axios.post(`${process.env.REACT_APP_API}/2fa/verify`, {
    token: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const disable2FA = async (password) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.post(`${process.env.REACT_APP_API}/2fa/disable`, {
    password,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const generateBackupCodes = async (password) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.post(`${process.env.REACT_APP_API}/2fa/backup-codes`, {
    password,
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const get2FAStatus = async () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.get(`${process.env.REACT_APP_API}/2fa/status`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// export const sync = async () => {
//   return await axios.get(`${process.env.REACT_APP_API}/sync`);
// };

// Permissions API
export const fetchMyPermissions = async () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.get(`${process.env.REACT_APP_API}/auth/my-permissions`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const globalLogout = async (userId) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.delete(`${process.env.REACT_APP_API}/globalLogout/${userId}` , {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const Logout = async () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  return await axios.post(`${process.env.REACT_APP_API}/auth/logout` ,{}, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
